import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { KMX_PHONE_BP } from '../../utils/constants';

interface ICarAnimationContainerProps {
    children: ReactNode[];
}

const CarAnimationContainer = ({ children }: ICarAnimationContainerProps) => (
    <Box
        className="buying-online-hero--animation-container"
        sx={(theme) => ({
            zIndex: 3,
            position: 'relative',
            minHeight: '21rem',
            maxHeight: '21rem',
            width: '21.375rem',
            [theme.breakpoints.up(KMX_PHONE_BP)]: {
                aspectRatio: '57 / 56',
                height: '100%',
                maxHeight: '33.8125rem',
                width: '100%',
            },
            '&&': {
                // hack to increase specificity above [theme.breakpoints.up()] block
                aspectRatio: { sm: 1.3 },
                minHeight: { sm: '25rem', md: '37.125rem', lg: '44rem' },
                maxHeight: { sm: '39.375rem', md: '51.5rem', lg: '44rem' },
            },
        })}
    >
        {children}
    </Box>
);

const CarImageContainer = () => (
    <Box
        className="buying-online-hero--car-container"
        sx={{
            width: '100%',
            maxWidth: { lg: '57.1875rem' },
            height: '100%',
            position: 'absolute',
            right: 0,
            clipPath: {
                xs: 'polygon(-100% 0, 96.75% 0, 77% 100%, -100% 100%)',
                sm: 'polygon(-100% 0, 97.5% 0, 82% 100%, -100% 100%)',
                lg: 'polygon(-200% 0, 97.5% 0, 82.25% 100%, -200% 100%)',
            },
            zIndex: 1,
        }}
    >
        <CarImage />
    </Box>
);

const CarImage = () => (
    <Box
        className="buying-online-hero--car-image"
        component="img"
        height="100%"
        src="/home/images/buying-online/hero/buyonline-hero-car.png"
        alt=""
        sx={{
            transform: {
                xs: 'translateX(24rem)',
                sm: 'translateX(48rem)',
                lg: 'translateX(64rem)',
            },
        }}
    />
);

const PhoneImageContainer = () => (
    <Stack
        className="buying-online-hero--phone-container"
        justifyContent="flex-end"
        direction="row"
        sx={(theme) => ({
            width: '21.375rem',
            [theme.breakpoints.up(KMX_PHONE_BP)]: {
                width: '100%',
                height: '100%',
                position: 'absolute',
                right: 0,
            },
        })}
    >
        <PhoneImage />
    </Stack>
);

const PhoneImage = () => (
    <Box
        component="img"
        height="100%"
        src="/home/images/buying-online/hero/buyonline-hero-phone.png"
        alt=""
        sx={{
            position: 'absolute',
        }}
    />
);

const CarAnimation = () => (
    <CarAnimationContainer>
        <CarImageContainer />
        <PhoneImageContainer />
    </CarAnimationContainer>
);

export default CarAnimation;
